/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *
 * @file ResourceCardThumbnail.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@greenville/mui-theme';
import { CONTENT_TITLE_OTHER_ICON, CONTENT_TYPE_KEYS } from '../../common/constants';
import ResourceUtils from '../../utils/ResourceUtils';

const ResourceCardThumbnail = ({ contentType }) => {
  const contentTypeDetails = ResourceUtils.getContentTypeDetails(contentType,
    CONTENT_TYPE_KEYS.TYPE);
  const iconName = contentTypeDetails
    && contentTypeDetails.length ? contentTypeDetails[0][CONTENT_TYPE_KEYS.ICON] : CONTENT_TITLE_OTHER_ICON;

  return (
    <div
      className={`resource-card-action-item-image ${contentType}`}
    >
      <div className="resource-card-action-item-image-circle">
        <Icon
          color="inherit"
          name={iconName}
          size="small"
        />
      </div>
    </div>);
};


ResourceCardThumbnail.propTypes = {
  contentType: PropTypes.string.isRequired
};

export default memo(ResourceCardThumbnail);
